import { ReactElement, useMemo } from 'react'
import { useWatch } from 'react-hook-form'
import { ImmutableVector3 } from '@modugen/ui-toolkit'
import RipLineSceneMarker from '@sceneMarkers/RipLineSceneMarker/marker'

interface Props {
  startFieldName?: string
  endFieldName?: string
}

const RipLineFormSceneMarker = ({
  startFieldName = 'rip_start',
  endFieldName = 'rip_end',
}: Props = {}): ReactElement => {
  const ripStart = useWatch({ name: startFieldName }) as Point | undefined
  const ripEnd = useWatch({ name: endFieldName }) as Point | undefined

  const ripStartVec = useMemo(
    () => (ripStart ? new ImmutableVector3(ripStart.x, ripStart.y, ripStart.z) : undefined),
    [ripStart],
  )
  const ripEndVec = useMemo(
    () => (ripEnd ? new ImmutableVector3(ripEnd.x, ripEnd.y, ripEnd.z) : undefined),
    [ripEnd],
  )

  return <RipLineSceneMarker ripStart={ripStartVec} ripEnd={ripEndVec} />
}

export default RipLineFormSceneMarker
